<template>
  <div>
    <table class="table">
      <thead>
        <slot name="columns">
          <tr>
            <th
              v-for="column in columns"
              :key="column"
              :class="{ viewMobile: column != 'Nombre' }"
            >
              {{ column }}
            </th>
            <th>Opciones</th>
          </tr>
        </slot>
      </thead>
      <tbody>
        <tr v-for="(item, index) in data" :key="index">
          <slot :row="item">
            <td
              v-for="column in columns"
              :key="column"
              class="col-7"
              :class="{ viewMobile: column != 'Nombre' }"
            >
              <span>{{ itemValue(item, column) }}</span>
              <div>
                <span style="font-size: 0.8rem"
                  >Hora:
                  {{ itemValue(item, "fecha_reporte").split(" ")[1] }}</span
                >
              </div>
              <div>
                <span style="font-size: 0.8rem"
                  >Fecha:
                  {{ itemValue(item, "fecha_reporte").split(" ")[0] }}</span
                >
              </div>
            </td>
            <td class="viewOptionsMobile">
              <!-- <button -->
              <!--   type="button" -->
              <!--   class="navbar-toggler navbar-toggler-right" -->
              <!--   aria-controls="navigation-index" -->
              <!--   aria-expanded="false" -->
              <!--   aria-label="Toggle navigation" -->
              <!--   :disabled="true" -->
              <!--   @click="openReportPopup(item)" -->
              <!-- > -->
              <!--   <i style="color: #004aad" class="nc-icon nc-paper-2"></i> -->
              <!-- </button> -->
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="openEditPopup(item)"
              >
                <i
                  style="color: #004aad"
                  class="nc-icon nc-settings-gear-64"
                ></i>
              </button>
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="openMapPopup(item)"
              >
                <i style="color: #004aad" class="nc-icon nc-delivery-fast"></i>
              </button>
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="openGeofencePopup(item)"
              >
                <i style="color: #004aad" class="nc-icon nc-map-big"></i>
              </button>
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="ringTag(item)"
              >
                <i style="color: #004aad" class="nc-icon nc-bell-55"></i>
              </button>
              <button
                type="button"
                class="navbar-toggler navbar-toggler-right"
                aria-controls="navigation-index"
                aria-expanded="false"
                aria-label="Toggle navigation"
                @click="refreshTag(item)"
              >
                <i style="color: #004aad" class="nc-icon nc-refresh-02"></i>
              </button>
            </td>
          </slot>
        </tr>
      </tbody>
    </table>
    <vs-popup
      classContent="popup-example"
      title="Geocercas"
      :active.sync="popupGeofence"
    >
      <div
        style="
          justify-content: space-between;
          padding-left: 3%;
          align-items: center;
        "
        class="row"
      >
        <div>
          <h4 style="margin: 0">{{ form.name }}</h4>
        </div>
        <div style="align-self: flex-end" class="col-xl-4 col-md-4">
          <button
            style="border: none; background-color: #004aad"
            class="btn btn-info btn-fill float-right"
            @click="activeCreateGeofence = true"
          >
            Crear Geocerca
          </button>
        </div>
      </div>
      <p v-if="geofences.length == 0">
        No hay Geocercas registrados para este Vehículo
      </p>
      <div v-else>
        <table class="table">
          <thead>
            <slot name="columns">
              <tr>
                <th>Nombre</th>
                <th>Estado</th>
                <th>Opciones</th>
              </tr>
            </slot>
          </thead>
          <tbody>
            <tr v-for="(item, index) in geofences" :key="index">
              <slot :row="item">
                <td>{{ item.name }}</td>
                <td v-if="item.status">Activo</td>
                <td v-else>Inactivo</td>
                <td>
                  <button
                    type="button"
                    class="navbar-toggler navbar-toggler-right"
                    aria-controls="navigation-index"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    @click="openEditGeofence(item)"
                  >
                    <i
                      style="color: #004aad"
                      class="nc-icon nc-settings-gear-64"
                    ></i>
                  </button>
                  <button
                    type="button"
                    class="navbar-toggler navbar-toggler-right"
                    aria-controls="navigation-index"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                    @click="confirmDeleteGeofence(item)"
                  >
                    <i
                      style="color: #004aad"
                      class="nc-icon nc-simple-remove"
                    ></i>
                  </button>
                </td>
              </slot>
            </tr>
          </tbody>
        </table>
      </div>
      <vs-popup
        classContent="popup-example"
        title="Mapa"
        :active.sync="activeEditGeofence"
      >
        <div>
          <div class="row">
            <div style="align-self: flex-end" class="col-xl-12 col-md-12">
              <button
                style="border: none; background-color: #004aad"
                class="btn btn-info btn-fill float-right"
                @click="editGeofence"
              >
                Editar
              </button>
            </div>
            <div class="row col-xl-12 col-md-12">
              <div class="col-xl-6 col-md-6">
                <vs-input
                  label="Nombre"
                  class="inputx"
                  v-model="formEditGeofence.name"
                />
              </div>
              <div
                style="align-self: flex-end; flex-basis: fit-content"
                class="col-xl-4 col-md-4"
              >
                <vs-checkbox
                  style="font-size: medium"
                  v-model="formEditGeofence.status"
                  >Estado</vs-checkbox
                >
              </div>
            </div>
          </div>
        </div>
        <div style="padding-top: 5%">
          <GmapMap
            ref="map"
            id="map1"
            :center="center"
            :zoom="9"
            :options="options"
            map-type-id="terrain"
            :disableDefaultUI="true"
          >
            <GmapPolygon
              :path="formEditGeofence.polygon"
              :options="polygonOptions"
              :editable="true"
              :draggable="true"
              :shapes="shapes"
              @path_changed="updateEdited($event)"
            ></GmapPolygon>
          </GmapMap>
        </div>
      </vs-popup>
      <vs-popup
        classContent="popup-example"
        title="Mapa"
        :active.sync="activeCreateGeofence"
      >
        <div style="display: flex; justify-content: space-between" class="row">
          <div style="align-self: flex-end" class="col-xl-12 col-md-12">
            <button
              style="border: none; background-color: #004aad"
              class="btn btn-info btn-fill float-right"
              @click="createGeofence"
            >
              Crear
            </button>
          </div>
          <div class="row col-xl-12 col-md-12">
            <div class="col-xl-6 col-md-6">
              <vs-input
                label="Nombre"
                class="inputx"
                v-model="formGeofence.name"
              />
            </div>
            <div
              style="align-self: flex-end; flex-basis: fit-content"
              class="col-xl-4 col-md-4"
            >
              <vs-checkbox
                style="font-size: medium"
                v-model="formGeofence.status"
                >Estado</vs-checkbox
              >
            </div>
          </div>
        </div>
        <div style="padding-top: 5%">
          <GmapMap
            ref="map"
            id="map1"
            :center="center"
            :zoom="9"
            :options="options"
            map-type-id="terrain"
            :disableDefaultUI="true"
          >
            <GmapDrawingManager
              :polygonOptions="polygonOptions"
              :options="drawingOptions"
              :shapes.sync="shapes"
            >
            </GmapDrawingManager>
          </GmapMap>
        </div>
      </vs-popup>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Reporte de Alertas"
      :active.sync="popupReport"
    >
      <div class="row">
        <div class="col-xl-4 col-md-3">
          <vs-input
            label="Nombre"
            disabled
            class="inputx"
            v-model="formReport.nombre"
          />
        </div>
        <div class="col-xl-4 col-md-3">
          <vs-input
            type="datetime-local"
            format-value="MM-DD-YYYY HH:mm"
            label="Inicio"
            class="inputx"
            v-model="formReport.inicio"
          />
        </div>
        <div class="col-xl-4 col-md-3">
          <vs-input
            type="datetime-local"
            label="Fin"
            class="inputx"
            v-model="formReport.fin"
          />
        </div>
        <div class="col-xl-4 col-md-3">
          <vs-select class="inputx" label="Evento" v-model="formReport.event">
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item, index) in options1"
            />
          </vs-select>
        </div>
        <div
          style="
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
          "
          class="buttonMobile col-xl-4 col-md-3"
        >
          <button
            style="border: none; background-color: #004aad"
            class="buttonMobile btn btn-info btn-fill float-right"
            @click="exportReportEventAlert()"
          >
            Exportar
          </button>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      title="Editar Localizador"
      :active.sync="popupEdit"
    >
      <div class="row">
        <div class="col-xl-4 col-md-4">
          <vs-input
            label="Nombre"
            class="inputx"
            placeholder="Nombre"
            v-model="form.nickname"
          />
        </div>
        <div class="col-xl-4 col-md-4" style="margin-top: 5px">
          <vs-select
            class="inputx selectExample"
            label="Icono"
            v-model="form.svg"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.name"
              v-for="(item, index) in availableIconTypes"
            />
          </vs-select>
        </div>
        <div class="col-xl-4 col-md-4" style="display: flex" v-if="form.svg">
          <vs-input
            class="color-svg"
            type="color"
            label="Color icono"
            v-model="form.svg_color"
          />
          <div class="col-4 pb-3" style="display: flex; align-items: flex-end">
            <img :src="getIcon(form.svg, form.svg_color)" />
          </div>
        </div>
        <div
          style="
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
          "
          class="buttonMobile col-xl-4 col-md-4 mt-3"
        >
          <button
            style="border: none; background-color: #004aad"
            class="btn btn-info btn-fill float-right"
            @click="editVehicle()"
          >
            Editar
          </button>
        </div>
      </div>
    </vs-popup>
    <vs-popup
      classContent="popup-example"
      :title="'Reporte de Posición ' + form.nickname"
      :active.sync="popupMap"
    >
      <div class="row">
        <div class="col-xl-5 col-md-5">
          <vs-input
            type="datetime-local"
            label="Inicio"
            class="inputx"
            v-model="inicio"
          />
        </div>
        <div class="col-xl-5 col-md-5">
          <vs-input
            type="datetime-local"
            label="Fin"
            class="inputx"
            v-model="fin"
          />
        </div>
        <div
          style="
            display: flex;
            align-items: flex-end;
            justify-content: flex-start;
          "
          class="buttonMobile col-xl-2 col-md-2"
        >
          <button
            style="border: none; background-color: #004aad"
            class="btn btn-info btn-fill float-right"
            @click="getEventsVehicle()"
          >
            Buscar
          </button>
        </div>
      </div>
      <div v-show="map">
        <div
          style="margin-top: 10px; padding-left: 0"
          class="col-xl-6 col-md-5"
        >
          <stats-card>
            <div slot="header" class="icon-warning">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-category">kilómetros</p>
              <h4 class="card-title">{{ kilometers }}</h4>
            </div>
          </stats-card>
        </div>
        <gmap-map
          id="map1"
          :center="center"
          :zoom="15"
          :options="options"
          map-type-id="terrain"
          :disableDefaultUI="true"
        >
          <gmap-info-window
            :options="infoOptions"
            :position="infoWindowPos"
            :opened="infoWinOpen"
            @closeclick="infoWinOpen = false"
          >
          </gmap-info-window>
          <gmap-marker
            :key="id"
            v-for="(tr, id) in events"
            :position="tr.center"
            :icon="tr.icon"
            :clickable="true"
            @click="toggleInfoWindow(tr, id)"
          >
          </gmap-marker>
          <gmap-polyline
            :options="{
              strokeOpacity: 1,
              strokeColor: '#808080',
              icons: [
                {
                  icon: { path: 'M 0,0 2,2 M 0,0 -2,2' },
                  offset: '0%',
                  repeat: '50px',
                },
              ],
            }"
            :path="flightPlanCoordinates"
          />
        </gmap-map>
      </div>
    </vs-popup>
    <vs-prompt
      @accept="deleteGeofence"
      :active.sync="activePrompt"
      acceptText="Aceptar"
      cancelText="Cancelar"
      title="Eliminar"
    >
      <div class="con-example-prompt">
        ¿Esta seguro que desea eliminar la Geocerca?
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import Vue from "vue";
import vuesax from "vuesax";
import StatsCard from "src/components/Cards/StatsCard.vue";
import "vuesax/dist/vuesax.css";
import "material-icons/iconfont/material-icons.css";
import GmapVue from "gmap-vue";
import getSecret from "../helpers/get-secret";
import { getIconUrl, getAvailableIconTypes } from "../helpers/iconHelper.js";
import { API_KEY } from "../pages/Maps/API_KEY";
const serverUrl = getSecret("SERVER_URL");

Vue.use(GmapVue, {
  load: {
    key: API_KEY,
  },
});
Vue.use(vuesax);

export default {
  name: "l-table",
  props: {
    columns: Array,
    data: Array,
  },
  components: {
    StatsCard,
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem("jwt_licencia")).id_company,
      popupReport: false,
      popupSms: false,
      popupEdit: false,
      popupMap: false,
      activePrompt: false,
      activeEditGeofence: false,
      popupGeofence: false,
      events: null,
      map: false,
      inicio: "",
      fin: "",
      kilometers: 0,
      flightPlanCoordinates: [],
      activeCreateGeofence: false,
      polygons: [],
      geofences: [],
      geofencesEdit: [],
      shapes: [],
      drawingOptions: {
        drawingControl: true, // Mostrar controles de dibujo en el mapa
        drawingControlOptions: {
          position: "TOP_CENTER", // Posición de los controles de dibujo
          drawingModes: ["marker", "polygon", "polyline", "circle"], // Modos de dibujo permitidos
        },
      },
      polygonOptions: {
        fillColor: "#FF0000",
        fillOpacity: 0.4,
        strokeWeight: 2,
        strokeColor: "#FF0000",
        draggable: false,
        editable: true,
        clickable: true,
      },
      options1: [
        { text: "Geocerca de Exclusion", value: 99 },
        { text: "Geocerca de Inclusion", value: 98 },
        { text: "Todos los Eventos", value: 1 },
      ],
      timeRing: {},
      form: {
        nickname: "",
        id: null,
        svg: null,
        svg_color: null,
      },
      formReport: {
        id: "",
        nombre: "",
        event: "",
        inicio: "",
        fin: "",
      },
      formGeofence: {
        name: "",
        status: true,
        polygon: [],
        id: "",
        id_company: "",
        tag_id: null,
      },
      formEditGeofence: {
        name: "",
        status: true,
        polygon: [{ lat: 1, lng: 1 }],
        id: "",
        id_company: "",
        tag_id: "",
      },
      infoWindowPos: null,
      availableIconTypes: [],
      infoWinOpen: false,
      infoOptions: {
        content: "",
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      center: {
        lat: 0,
        lng: 0,
      },
      options: {
        styles: [
          {
            featureType: "water",
            stylers: [
              { saturation: 43 },
              { lightness: -11 },
              { hue: "#0088ff" },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              { hue: "#ff0000" },
              { saturation: -100 },
              { lightness: 99 },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{ color: "#808080" }, { lightness: 54 }],
          },
          {
            featureType: "landscape.man_made",
            elementType: "geometry.fill",
            stylers: [{ color: "#ece2d9" }],
          },
          {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{ color: "#ccdca1" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#767676" }],
          },
          {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{ color: "#ffffff" }],
          },
          { featureType: "poi", stylers: [{ visibility: "off" }] },
          {
            featureType: "landscape.natural",
            elementType: "geometry.fill",
            stylers: [{ visibility: "on" }, { color: "#b8cb93" }],
          },
          { featureType: "poi.park", stylers: [{ visibility: "off" }] },
          {
            featureType: "poi.sports_complex",
            stylers: [{ visibility: "off" }],
          },
          { featureType: "poi.medical", stylers: [{ visibility: "off" }] },
          {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }],
          },
        ],
      },
    };
  },
  created() {
    this.availableIconTypes = getAvailableIconTypes();
  },
  watch: {
    activeCreateGeofence: function (newVal) {
      if (!newVal) {
        this.formGeofence = {
          name: "",
          status: true,
          polygon: [],
          id: "",
          id_company: "",
          tag_id: "",
        };
      }
    },
    activeEditGeofence: function (newVal) {
      if (!newVal) {
        this.formEditGeofence = {
          name: "",
          status: true,
          polygon: [{ lat: 1, lng: 1 }],
          id: "",
          id_company: "",
          tag_id: "",
        };
        this.geofencesEdit = [];
      }
    },
  },
  methods: {
    refreshTag(item) {
      this.$vs.loading({
        type: "point",
        text: "Enviando solicitud...",
        color: "#004aad",
      });
      if (
        this.timeRing[item.id] &&
        Date.now() - this.timeRing[item.id] < 60000
      ) {
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>Debe esperar 1 minuto para volver a enviar la solicitud.</span>`,
          icon: "nc-icon nc-support-17",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
        });
        setTimeout(() => {
          this.$vs.loading.close();
        }, 1000);
        return;
      }
      this.axios
        .get(serverUrl + "/api/refresh-tag/" + item.id)
        .then((res) => {
          if (res.data.status == 200) {
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Solicitud enviada.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
            this.$root.$emit("getList");
          }
          this.timeRing[item.id] = Date.now();
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.$vs.loading.close();
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió al enviar la solicitud.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    ringTag(item) {
      this.$vs.loading({
        type: "point",
        text: "Enviando solicitud...",
        color: "#004aad",
      });
      if (
        this.timeRing[item.id] &&
        Date.now() - this.timeRing[item.id] < 60000
      ) {
        this.$notifications.notify({
          message: `<span><b>¡Error!</b><br>Debe esperar 1 minuto para volver a enviar la solicitud.</span>`,
          icon: "nc-icon nc-support-17",
          horizontalAlign: "right",
          verticalAlign: "bottom",
          type: "danger",
        });
        setTimeout(() => {
          this.$vs.loading.close();
        }, 1000);
        return;
      }
      this.axios
        .get(serverUrl + "/api/ring-tag/" + item.id)
        .then((res) => {
          if (res.data.status == 200) {
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Solicitud enviada, su dispositivo sonara en aproximadamente 15 segundos.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          }
          this.timeRing[item.id] = Date.now();
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.$vs.loading.close();
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió al enviar la solicitud.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    getIcon(type, color) {
      return getIconUrl(type, color);
    },
    editGeofence() {
      this.$vs.loading({
        type: "point",
        text: "Guardando...",
        color: "#004aad",
      });
      if (this.geofencesEdit.length > 0) {
        const path = this.geofencesEdit.getArray();
        this.coords = [];
        path.forEach((coord) => {
          const lat = coord.lat();
          const lng = coord.lng();
          const point = { lat: lat, lng: lng };
          this.coords.push(point);
        });
        this.polygons.push({
          path: this.coords,
        });
        this.formEditGeofence.polygon = this.coords;
      }
      this.axios
        .post(serverUrl + "/api/editGeofenceTag", this.formEditGeofence)
        .then((res) => {
          if (res.data.status == 200) {
            this.activeEditGeofence = false;
            this.popupGeofence = false;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Geocerca Editada.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió al editar la geocercas.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
          this.$vs.loading.close();
        });
    },
    updateEdited($event) {
      this.geofencesEdit = $event;
    },
    openEditGeofence(item) {
      this.formEditGeofence.name = item.name;
      this.formEditGeofence.status = item.status;
      this.formEditGeofence.polygon = item.polygon;
      this.formEditGeofence.id = item.id;
      this.shapes = item.polygon;
      this.activeEditGeofence = true;
    },
    confirmDeleteGeofence(item) {
      this.activePrompt = true;
      this.id_item = item.id;
      this.account = item;
    },
    deleteGeofence() {
      this.$vs.loading({
        type: "point",
        text: "Eliminando...",
        color: "#004aad",
      });
      this.axios
        .get(serverUrl + "/api/deleteGeofenceTag/" + this.id_item)
        .then((res) => {
          if (res.data.status == 200) {
            this.popupGeofence = false;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Geocerca Eliminado con Éxito.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar la Geocerca.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al eliminar la Geocerca.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
          this.$vs.loading.close();
        });
    },
    createGeofence() {
      this.$vs.loading({
        type: "point",
        text: "Guardando...",
        color: "#004aad",
      });
      this.formGeofence.id_company = this.id_company;
      const path = this.shapes[0].overlay.getPath().getArray();
      this.coords = [];
      path.forEach((coord) => {
        const lat = coord.lat();
        const lng = coord.lng();
        const point = { lat: lat, lng: lng };
        this.coords.push(point);
      });
      this.polygons.push({
        path: this.coords,
      });
      this.formGeofence.polygon = this.coords;
      this.axios
        .post(serverUrl + "/api/createGeofenceTag", this.formGeofence)
        .then((res) => {
          if (res.data.status == 200) {
            this.activeCreateGeofence = false;
            this.popupGeofence = false;
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Geocerca Creada.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió al crear la geocercas.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
          this.$vs.loading.close();
        });
    },
    openReportPopup(item) {
      this.popupReport = true;
      this.formReport.id = item.id;
      this.formReport.nombre = item.nombre;
      this.formReport.inicio = "";
      this.formReport.fin = "";
      this.formReport.event = null;
    },
    openEditPopup(item) {
      this.popupEdit = true;
      this.form.id = item.id;
      this.form.nickname = item.nickname;
      this.form.svg = item.svg;
      this.form.svg_color = item.svg_color;
    },
    openMapPopup(item) {
      this.popupMap = true;
      this.form.id = item.id;
      this.events = null;
      this.map = false;
      this.inicio = "";
      this.fin = "";
    },
    openGeofencePopup(item) {
      this.$vs.loading({
        type: "point",
        text: "Consultando...",
        color: "#004aad",
      });
      this.axios
        .get(serverUrl + "/api/getGeofenceByTag/" + item.id)
        .then((res) => {
          if (res.data.status == 200) {
            this.formGeofence.tag_id = item.id;
            this.form.nickname = item.nickname;
            this.center = {
              lat: parseFloat(item.last_latitude),
              lng: parseFloat(item.last_longitude),
            };
            this.popupGeofence = true;
            this.geofences = res.data.geofences;
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió al obtener la lista de geocercas.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          console.log(err);
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió al obtener la lista de geocercas.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
          this.$vs.loading.close();
        });
    },
    getReportEventAlert() {
      this.axios
        .get(
          serverUrl +
            "/api/getReportAlertTag/" +
            this.formReport.id +
            "/" +
            this.formReport.inicio +
            "/" +
            this.formReport.fin +
            "/" +
            this.formReport.event
        )
        .then((res) => {
          if (res.data.status == 200) {
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al obtener el reporte.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
          this.popupReport = false;
        })
        .catch((err) => {
          this.popupReport = false;
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al obtener el reporte.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
        });
    },
    exportReportEventAlert() {
      let url2 = serverUrl;
      let url3 = `${url2}/api/export-report-alert-tag/${this.formReport.id}/${this.formReport.inicio}/${this.formReport.fin}/${this.formReport.event}`;
      window.open(url3, "_blank");
    },
    getEventsVehicle() {
      this.flightPlanCoordinates = [];
      this.axios
        .get(
          serverUrl +
            "/api/getEventsTag/" +
            this.form.id +
            "/" +
            this.inicio +
            "/" +
            this.fin
        )
        .then((res) => {
          if (res.data.status == 200) {
            this.events = res.data.events;
            this.center = {
              lat: parseFloat(this.events[0].latitude),
              lng: parseFloat(this.events[0].longitude),
            };

            this.events.forEach((event) => {
              event.center = {
                lat: parseFloat(event.latitude),
                lng: parseFloat(event.longitude),
              };
              this.flightPlanCoordinates.push(event.center);
              event.evento = "Test";
              event.infoText =
                "<strong>Evento:</strong>" +
                event.evento +
                "<br><strong>Fecha:</strong>" +
                event.created_at;
            });
            this.kilometers = 0;
            for (let i = 0; i < this.events.length - 1; i++) {
              const puntoActual = this.events[i];
              const puntoSiguiente = this.events[i + 1];
              const latitudActual = puntoActual.latitude;
              const longitudActual = parseFloat(puntoActual.longitude);
              const latitudSiguiente = puntoSiguiente.latitude;
              const longitudSiguiente = parseFloat(puntoSiguiente.longitude);
              const distancia = this.calcularDistancia(
                latitudActual,
                longitudActual,
                latitudSiguiente,
                longitudSiguiente
              );
              this.kilometers += distancia;
            }
            this.kilometers = this.kilometers.toFixed(2);
            this.map = true;
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al obtener el reporte de ubicación.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
          this.popupEdit = false;
        })
        .catch((err) => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al obtener el reporte de ubicación.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
          console.log("getEventsVehicle:" + err);
        });
    },
    calcularDistancia(lat1, lon1, lat2, lon2) {
      const radioTierra = 6371; // Radio de la Tierra en kilómetros
      const dLat = this.toRadians(lat2 - lat1);
      const dLon = this.toRadians(lon2 - lon1);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toRadians(lat1)) *
          Math.cos(this.toRadians(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const distancia = radioTierra * c;
      return distancia;
    },
    toRadians(grados) {
      return grados * (Math.PI / 180);
    },
    editVehicle() {
      this.axios
        .post(serverUrl + "/api/editTag", this.form)
        .then((res) => {
          if (res.data.status == 200) {
            this.$root.$emit("getList");
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Localizador Actualizado.</span>`,
              icon: "nc-icon nc-send",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "info",
            });
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar el Localizador.</span>`,
              icon: "nc-icon nc-support-17",
              horizontalAlign: "right",
              verticalAlign: "bottom",
              type: "danger",
            });
          }
          this.popupEdit = false;
        })
        .catch((err) => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar el Localizador.</span>`,
            icon: "nc-icon nc-support-17",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger",
          });
          this.popupEdit = false;
        });
    },
    hasValue(item, column) {
      return item[column.toLowerCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toLowerCase()];
    },
    toggleInfoWindow: function (vehicle, cuenta) {
      this.infoWindowPos = vehicle.center;
      this.infoOptions.content = vehicle.infoText;
      if (this.currentMidx == cuenta) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = cuenta;
      }
    },
  },
};
</script>
<style>
.vs-dialog-accept-button {
  background: #004aad !important;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  padding: 10px;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  color: #fff;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: transparent;
}
.color-svg {
  input {
    height: 2rem !important;
  }
}

input {
  height: auto !important;
}

.vs-input {
  float: left;
  width: 50%;
  margin-top: 5px;
}

.vs-select {
  float: left;
  width: 50%;
  margin-top: 5px;
}

.con-select {
  width: auto !important;
  clear: both;
}

#map1 {
  min-height: 500px;
  width: 100% !important;
  height: auto;
}

.vs-button {
  height: auto !important;
}

@media (max-width: 767px) {
  .viewMobile {
    display: none;
  }

  .viewOptionsMobile {
    display: contents !important;
  }

  .buttonMobile {
    padding-top: 3%;
  }

  .buttonsCommandMobile {
    flex-direction: column;
  }
}

.card {
  margin-bottom: 10px !important;
}
</style>
